// Jonker Sailplanes — the FRONTEND face of the client config seam.
//
// The screens import these named exports from '@client/config/client.config';
// in this fork that alias resolves HERE (web/vite.config.js — the fork's
// one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js
// (the server-side seam). The config suite asserts the two never drift —
// edit BOTH or the runner goes RED.

export const BRAND_NAME = 'Jonker Sailplanes';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Jonker Sailplanes — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

// Must match a group name in the site's data (permission checks, admin UI).
export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces — mirrors the server seam's workspacesEnabled (ON for this client).
export const WORKSPACES_ENABLED = true;

// Browser storage namespace (localStorage, BroadcastChannel).
export const STORAGE_PREFIX = 'jonker-sailplanes';

// The architectural hierarchy (see ../config/client.config.js — whiteboard
// first). Generic defaults until the client's cloned data says otherwise.
export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
// Compared case-sensitively by several read paths (coupling: link-case).
export const LINK_TYPE_NAME = 'Hierarchy';

// The field kanban groups/colours by — null until a board exists.
export const WPO_FIELD = null;

// Accent colour as RGB (JS canvas + generated chrome). #1886C6.
export const ACCENT_RGB = { r: 24, g: 134, b: 198 };

// Client Customs proxy host allowlist (enforced server-side; mirrors the
// server seam's customs.allowedHosts — the config suite checks the pair).
export const CUSTOMS_ALLOWED_HOSTS = [];
